<!-- Navigation -->
<fuse-vertical-navigation
    class=" bg-gray-100 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="data.navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user-menu [showAvatar]="true">
                    <mat-icon svgIcon="heroicons_outline:menu"></mat-icon>
                </user-menu>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">
            <div class="relative w-24 h-24">
                <img
                    #avatarImg
                    class="w-full h-full rounded-full"
                    [src]="urlAvatar"
                    alt=""
                    (error)="setFallbackAvatar()">
            </div>
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{data.user.name}}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{data.user.email}}
                </div>
                <div class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{data.user.roldes}}
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-20 mb-4 opacity-12">
            <img
                class="w-44"
                src="assets/images/logo/logo.png">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-2">
            <fuse-fullscreen></fuse-fullscreen>
            <messages [messages]="data.messages"></messages>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
    *ngIf="paymentType === 'trial'"
    [ngClass]="{'expires': expirated}">
        <span class="font-medium text-secondary" *ngIf="dateMax && !expirated" class="bg-rose-800">
            Está utilizando un periodo de evaluación <span class="font-bold italic ">NutriBe</span> que estará disponible hasta el {{  dateMax | date: 'dd/MM/yyyy' }},
            si lo desea puede adquirir un plan haciendo click  <a class="font-bold" [routerLink]="['/acount', 'settings']">aquí</a>. </span>

        <span *ngIf="dateMax && expirated">
            El tiempo de evaluación <span class="font-bold italic ">NutriBe</span>  concluyó  el {{  dateMax | date: 'dd/MM/yyyy' }}, lo invitamos a adquirir un paquete haciendo click <a class="font-bold" [routerLink]="['/acount', 'settings']">aquí</a>.
        </span>
    </div>


    <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"
    *ngIf="paymentType === 'payment' && expiratedPayment !== 0"
    [ngClass]="{'expires': expirated}">
        <span class="font-medium text-secondary" *ngIf="expiratedPayment === 1" class="bg-rose-800">
            Su suscripción NutriBe concluyó el {{  dateMax | date: 'dd/MM/yyyy' }}, y no fue posible realizar el cargo,
            lo invitamos a revisar sus datos bancarios para seguir disfrutando de <span class="font-bold italic ">NutriBe</span>.
            Podrá seguir utilizando la plataforma hasta el {{  dateMaxFinal | date: 'dd/MM/yyyy' }}. Para revisar sus suscripción de click <a class="font-bold" [routerLink]="['/acount', 'settings']">aquí</a>.
        </span>

        <span class="font-medium text-secondary" *ngIf="expiratedPayment === 2" class="bg-rose-800">
            Su suscripción NutriBe concluyó el {{  dateMax | date: 'dd/MM/yyyy' }}, para seguir utilizando la plataforma por favor revise y actualice sus datos bancarios haciendo click <a class="font-bold" [routerLink]="['/acount', 'settings']">aquí</a>.
        </span>
    </div>

</div>
